const BENGUET_CITIES = [
    '141102',
    '141110',
];
const ILOCOS_NORTE_CITIES = [
    '012812',
];
const ILOCOS_SUR_CITIES = [
    '012906',
    '012934',
];
const LA_UNION_CITIES = [
    '013314',
];
const PANGASINAN_CITIES = [
    '015518',
    '015532',
    '015546',
];
const CAGAYAN_CITIES = [
    '021529',
];
const ISABELA_CITIES = [
    '023108',
    '023135',
];
const BATAAN_CITIES = [
    '030803',
    '030804',
];
const BULACAN_CITIES = [
    '031402',
    '031403',
    '031404',
    '031405',
    '031408',
    '031410',
    '031411',
    '031412',
    '031417',
    '031420',
    '031423',
];
const NUEVA_ECIJA_CITIES = [
    '034903',
    '034908',
    '034926',
    '034928',
];
const PAMPANGA_CITIES = [
    '035401',
    '035407',
    '035409',
    '035416',
];
const TARLAC_CITIES = [
    '036904',
    '036905',
    '036916',
];
const ZAMBALES_CITIES = [
    '037107',
    '037114',
];
const BATANGAS_CITIES = [
    '041005',
    '041006',
    '041014',
    '041017',
    '041019',
    '041023',
    '041028',
    '041031',
];
const CAVITE_CITIES = [
    '042103',
    '042104',
    '042105',
    '042106',
    '042123',
    '042108',
    '042109',
    '042111',
    '042115',
    '042116',
    '042117',
    '042118',
    '042119',
    '042120',
    '042122',
];
const LAGUNA_CITIES = [
    '043403',
    '043404',
    '043405',
    '043411',
    '043419',
    '043424',
    '043425',
    '043426',
    '043428',
];
const QUEZON_CITIES = [
    '045608',
    '045624',
    '045648',
];
const RIZAL_CITIES = [
    '045801',
    '045802',
    '045804',
    '045805',
    '045808',
    '045811',
    '045813',
];
const ORIENTAL_MINDORO_CITIES = [
    '175205',
];
const PALAWAN_CITIES = [
    '175316',
];
const ALBAY_CITIES = [
    '050503',
    '050506',
    '050508',
    '050514',
    '050517',
];
const CAMARINES_NORTE_CITIES = [
    '051603',
];
const CAMARINES_SUR_CITIES = [
    '051716',
    '051724',
];
const CATANDUANES_CITIES = [
    '052011',
];
const SORSOGON_CITIES = [
    '056216',
];
const CAPIZ_CITIES = [
    '061914',
];
const ILOILO_CITIES = [
    '063022',
];
const NEGROS_OCCIDENTAL_CITIES = [
    '064501',
    '064504',
    '064515',
    '064526',
];
const BOHOL_CITIES = [
    '071242',
];
const CEBU_CITIES = [
    '072217',
    '072219',
    '072223',
    '072226',
    '072227',
    '072230',
    '072232',
    '072250',
];
const NEGROS_ORIENTAL_CITIES = [
    '074610',
];
const LEYTE_CITIES = [
    '083747',
];
const SAMAR_CITIES = [
    '086005',
];
const ZAMBOANGA_DEL_NORTE_CITIES = [
    '097202',
];
const ZAMBOANGA_DEL_SUR_CITIES = [
    '097332',
];
const BUKIDNON_CITIES = [
    '101321',
];
const LANAO_DEL_NORTE_CITIES = [
    '103504',
];
const MISAMIS_ORIENTAL_CITIES = [
    '104305',
];
const DAVAO_DEL_NORTE_CITIES = [
    '112315',
    '112319',
];
const DAVAO_DEL_SUR_CITIES = [
    '112402',
    '112403',
];
const DAVAO_ORIENTAL_CITIES = [
    '112509',
];
const SOUTH_COTABATO_CITIES = [
    '126303',
    '126306',
];
const SULTAN_KUDARAT_CITIES = [
    '126511',
];
const AGUSAN_DEL_NORTE_CITIES = [
    '160202',
];
const SURIGAO_DEL_NORTE_CITIES = [
    '166724',
];
export const PANDAGO_ALLOWED_REGIONS = [
    '13',
    '14',
    '01',
    '02',
    '03',
    '04',
    '17',
    '05',
    '06',
    '07',
    '08',
    '09',
    '10',
    '11',
    '12',
    '16',
];
export const PANDAGO_ALLOWED_CITIES = [
    ...BENGUET_CITIES,
    ...ILOCOS_NORTE_CITIES,
    ...ILOCOS_SUR_CITIES,
    ...LA_UNION_CITIES,
    ...PANGASINAN_CITIES,
    ...CAGAYAN_CITIES,
    ...ISABELA_CITIES,
    ...BATAAN_CITIES,
    ...BULACAN_CITIES,
    ...NUEVA_ECIJA_CITIES,
    ...PAMPANGA_CITIES,
    ...TARLAC_CITIES,
    ...ZAMBALES_CITIES,
    ...BATANGAS_CITIES,
    ...CAVITE_CITIES,
    ...LAGUNA_CITIES,
    ...QUEZON_CITIES,
    ...RIZAL_CITIES,
    ...ORIENTAL_MINDORO_CITIES,
    ...PALAWAN_CITIES,
    ...ALBAY_CITIES,
    ...CAMARINES_NORTE_CITIES,
    ...CAMARINES_SUR_CITIES,
    ...CATANDUANES_CITIES,
    ...SORSOGON_CITIES,
    ...CAPIZ_CITIES,
    ...ILOILO_CITIES,
    ...NEGROS_OCCIDENTAL_CITIES,
    ...BOHOL_CITIES,
    ...CEBU_CITIES,
    ...NEGROS_ORIENTAL_CITIES,
    ...LEYTE_CITIES,
    ...SAMAR_CITIES,
    ...ZAMBOANGA_DEL_NORTE_CITIES,
    ...ZAMBOANGA_DEL_SUR_CITIES,
    ...BUKIDNON_CITIES,
    ...LANAO_DEL_NORTE_CITIES,
    ...MISAMIS_ORIENTAL_CITIES,
    ...DAVAO_DEL_NORTE_CITIES,
    ...DAVAO_DEL_SUR_CITIES,
    ...DAVAO_ORIENTAL_CITIES,
    ...SOUTH_COTABATO_CITIES,
    ...SULTAN_KUDARAT_CITIES,
    ...AGUSAN_DEL_NORTE_CITIES,
    ...SURIGAO_DEL_NORTE_CITIES,
];
